import axios from "axios";
import firebase from "./firebase";
import request from "../infra/request";
import _ from "lodash";
import { CLIENT_APPOINTMENTS } from "../constants";
import { isManualArchiveWorkflowEnabled } from "../infra/featureToggle";
const moment = require("moment");

export const fetchSpecialistFillRateReport = async ({ startDate, endDate }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  if (!startDate || !endDate) {
    throw new Error("Invalid parameters, startDate and endDate can not be empty!");
  }
  const start = moment(startDate, "YYYY-MM-DD").format("YYYYMMDD");
  const end = moment(endDate, "YYYY-MM-DD").format("YYYYMMDD");

  return axios.get(`${process.env.REACT_APP_API_HOST}/admin/report/fill-rate`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
    params: { start, end },
  });
};

export const fetchWorkflowReport = async ({ startDate, endDate, specialistProfiles }) => {
  if (!startDate || !endDate) {
    throw new Error("Invalid parameters, startDate and endDate can not be empty!");
  }
  const startDateTime = moment(`${startDate}T00:00:00`, "YYYY-MM-DDTHH:mm:ss").unix();
  const endDateTime = moment(`${endDate}T23:59:59`, "YYYY-MM-DDTHH:mm:ss").unix();
  // The backend makes the query this function used to make and sends only the fields the rows
  // below read; a column that reads another field needs it added there (WORKFLOW_REPORT_FIELDS).
  const response = await request.get("/admin/report/workflows-created", {
    params: { start: startDateTime, end: endDateTime },
  });
  const clientAppointments = response.data.workflows;

  return await Promise.all(
    clientAppointments.map(async (clientAppointment) => {
      const expiredTime = _.get(clientAppointment, "referral.endDate");
      const expiredMoment = expiredTime === null ? null : moment(expiredTime);

      const createdTimeStamp = _.get(clientAppointment, "creationTimestamp", moment().unix());
      let dueWeeks = "";
      let weeksToAppointment = _.get(clientAppointment, "appointment_t.weeks_to_appointment", "");
      if (!_.isEmpty(weeksToAppointment)) {
        weeksToAppointment = _.toNumber(weeksToAppointment);
        const status = _.get(clientAppointment, "appointment_t.status", "");
        if (!CLIENT_APPOINTMENTS.includes(status)) {
          //Return the weeksToAppointment at status last update time if is not active status
          const statusLastUpdateAt = _.get(clientAppointment, "appointment_t.statusLastUpdateAt", moment().unix());
          dueWeeks = moment
            .unix(createdTimeStamp)
            .add(weeksToAppointment, "w")
            .diff(moment.unix(statusLastUpdateAt), "w");
        } else {
          dueWeeks = moment.unix(createdTimeStamp).add(weeksToAppointment, "w").diff(moment(), "w");
        }
      }

      return {
        createdAt: _.get(clientAppointment, "creationTimestamp", ""),
        urn: _.get(clientAppointment, "client.ExternalId", ""),
        category: _.get(clientAppointment, "category", ""),
        client: `${_.get(clientAppointment, "client.firstName", "")} ${_.get(
          clientAppointment,
          "client.lastName",
          ""
        )}`,
        DOB: _.get(clientAppointment, "client.dateOfBirth", ""),
        practitioner: `${_.get(clientAppointment, "practitioner.firstName", "")} ${_.get(
          clientAppointment,
          "practitioner.lastName",
          ""
        )}`,
        hospital: _.get(clientAppointment, "location.name", ""),
        specialty:
          specialistProfiles.find(({ id }) => clientAppointment.practitioner?.practitionerId === id)?.specialties?.[0]
            ?.name || "",
        appointmentDate: _.get(clientAppointment, "appointment.startDateTime", ""),
        newOrReview: _.get(clientAppointment, "appointment_t.is_new_appointment", false) === true ? "New" : "Review",
        expiryDate: expiredMoment === null ? "" : expiredMoment.format("YYYY-MM-DD HH:mm"),
        dueWeeks,
        status: _.get(clientAppointment, "appointment_t.status", ""),
        ...(isManualArchiveWorkflowEnabled ? { archived: clientAppointment.archived === true ? "Yes" : "No" } : {}),
      };
    })
  );
};

export const fetchNewAptWaitingTimeReport = async () => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_API_HOST}/admin/report/new-apt-waiting-time`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
  });
};

export const fetchDailyBookedReport = async ({ startDate, endDate }) => {
  if (!startDate || !endDate) {
    throw new Error("Invalid parameters, startDate and endDate can not be empty!");
  }
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_API_HOST}/admin/report/daily-booked`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
    params: { startDate, endDate },
  });
};

export const fetchAppointmentReport = async ({ date }) => {
  console.log(date);
  if (!date) {
    throw new Error("Invalid parameters, date can not be empty!");
  }
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_API_HOST}/admin/report/appointments`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
    params: { date },
  });
};

export const fetchWorkflowsByAppointmentCreatedReport = async ({ startDate, endDate }) => {
  if (!startDate || !endDate) {
    throw new Error("Invalid parameters, startDate and endDate can not be empty!");
  }
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_API_HOST}/admin/report/workflows-by-appointment-created`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
    params: { startDate, endDate },
  });
};
